import JsonResponse from "csi/comm/JsonResponse";
import { Field as FieldType } from "csi/def/Field";
import FormWidget from "csi/form/Widget";
import Names, { StoreNames } from "csi/store/Names";
import csiStore from "csi/store/_base";
import declare from "dojo/_base/declare";
import { fetchUsersWithProofingRoles } from "../ProofService";

export = declare(FormWidget, {
	/** @property {Object[]} - proofAdminItems items for the proof admin store */
	proofAdminItems: null,

	/**
	 * @override
	 * Get the search for all proof admins onViewStart.
	 */
	onViewStart(dfds: Promise<JsonResponse>[]): void {
		dfds.push(fetchUsersWithProofingRoles(true, null, null, (nodes) => {
			this.proofAdminItems = nodes
				// exclude the user node that was clicked
				.filter((n) => n.$URL !== this.getFormSourceNode().$URL)
				.map((n) => csiStore.nameObject(n));
		} ));
	},

	/**
	 * @override
	 * The store for the Proofing License Users should skip the current node.
	 */
	getFieldStore(field: FieldType, value: string): StoreNames {
		if (field.getControlName() === "ProofingLicenseUsers") {
			return new Names({ data: this.proofAdminItems });
		}
		return this.inherited<StoreNames>(arguments);
	},
});